<template>
  <div class="page-index">
    <div class="option1">
      <div class="shop-logo">
        <img src="../../assets/images/icon.png" alt />
        <div class="logo-title">美业获客，不止发传单</div>
      </div>
      <div class="shop-title">
        <div class="title-item1">精准获客 裂变引流</div>
        <div class="title-item2">让你的顾客主动帮你传播</div>
      </div>
      <van-button @click="goSetShopPage" class="van-button1" round>立即开通</van-button>
      <div class="shop-ad">
        <span>得有店 美业小程序</span>
        <span>拼团 分销 秒杀 会员 储值</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goSetShopPage() {
      this.$router.push({
        name: 'beauty-register',
      })
    },
  },
}
</script>

<style lang="css" scoped>
.page-index {
  height: 100%;
   background: linear-gradient(
    135deg,
    rgba(111, 100, 241, 1),
    rgba(111, 100, 241, 0.5)
  );
}
.option1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 65px;
  box-sizing: border-box;
  background: url('http://resource.deiyou.net/deiyoudian/FhdLPimiqaInyxpKp7aYDnGhxH1uRGD2xm0C1voeGT51/1599699889uKdXd.png?imageView2/2/w/800/800/0/format') no-repeat center 50px;
  background-size: cover;
}
.shop-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.shop-logo .logo-title {
  margin-top: 18px;
  font-family: YOUSHEhaoshenti;
  font-size: 18px;
  color: #fff;
}
.shop-logo > img {
  width: 135px;
  height: 42px;
  margin-top: 20px;
}
.shop-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}
.shop-title > img {
  width: 289px;
  height: 33px;
}
.title-item1 {
  font-family: YOUSHEhaoshenti;
  font-size: 40x;
  font-weight: bold;
  color: #fff;
  letter-spacing: 1px;
}
.title-item2 {
  margin-top: 10px;
  font-size: 24px;
  color: #fff;
  font-family: YOUSHEhaoshenti;
  letter-spacing: 1px;
}
.van-button1 {
  width: 160px;
  height: 49px;
  margin-top: 132px;
  color: #6f64f1;
  font-weight: 700;
  font-size: 16px;
}
.shop-ad {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  font-size: 18px;
  color: #fff;
}
.shop-ad span {
  margin-bottom: 5px;
}
</style>